import React from "react";

const formatText = (text) => {
  return text.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < text.split("\n").length - 1 && <br />}
    </React.Fragment>
  ));
};

const InfoText = ({ desc }) => {
  return (
    <div className="mb-7 justify-center flex mt-[-20px]">
      <p className="text-sm text-brand-point break-keep py-3 px-6 justify-center flex text-center w-fit border-[1px] border-brand-point rounded-3xl">
        {formatText(desc)}
      </p>
    </div>
  );
};

export default InfoText;
